import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { sendSupportMessage } from 'actions/support.action'
import { RootState } from 'reducers/rootReducer'
import ISupport, { ISupportMutation } from 'models/Support/ISupport'
import { TranslationKeys } from 'types/TranslationKeys'

export interface FormProps {
  t: (key: TranslationKeys) => string
}

export const useForm = (props: FormProps) => {
  const dispatch = useAppDispatch()

  const [isOtherDisplayed, setIsOtherDisplayed] = useState(false)
  const [selectedMethod, setSelectedMethod] = useState('none')
  const [selectedAmount, setSelectedAmount] = useState(0)
  const [otherAmount, setOtherAmount] = useState(0)

  const isLoading = useSelector((state: RootState) => state.support.isLoading)
  const isSendSupportMessageSuccess = useSelector(
    (state: RootState) => state.support.isSendSupportMessageSuccess
  )
  const isSendSupportMessageFailed = useSelector(
    (state: RootState) => state.support.isSendSupportMessageFailed
  )

  const [supportFormData, setSupportFormData] = useState<ISupport>({
    name: '',
    phone: '',
    method: '',
    amount: '',
    note: '',
  })

  const handleControllerChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target
    setSupportFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      if (
        supportFormData.name !== '' ||
        supportFormData.phone !== '' ||
        supportFormData.amount !== '' ||
        supportFormData.method !== ''
      ) {
        const supportMutation: ISupportMutation = {
          mutations: [
            {
              create: {
                _type: 'form',
                ...supportFormData,
              },
            },
          ],
        }

        await dispatch(sendSupportMessage(supportMutation))
      }
    } catch (error) {
      console.error('Error submitting form:', error)
    }
  }

  useEffect(() => {
    if (selectedAmount === 101) setIsOtherDisplayed(true)
    else {
      setIsOtherDisplayed(false)

      setSupportFormData((prevState) => ({
        ...prevState,
        ['amount']: selectedAmount.toString(),
      }))

      if (otherAmount !== 0) setOtherAmount(0)
    }
  }, [selectedAmount])

  useEffect(() => {
    if (selectedMethod !== 'none') {
      setSupportFormData((prevState) => ({
        ...prevState,
        ['method']: selectedMethod,
      }))
    }
  }, [selectedMethod])

  useEffect(() => {
    if (otherAmount !== 0) {
      setSupportFormData((prevState) => ({
        ...prevState,
        ['amount']: otherAmount.toString(),
      }))
    }
  }, [otherAmount])

  useEffect(() => {
    if (isSendSupportMessageSuccess)
      setSupportFormData({
        name: '',
        phone: '',
        method: '',
        amount: '',
        note: '',
      })
  }, [isSendSupportMessageSuccess])

  return {
    ...props,
    isOtherDisplayed,
    method: selectedMethod,
    amount: selectedAmount,
    otherAmount,
    supportFormData,
    isLoading,
    isSendSupportMessageSuccess,
    isSendSupportMessageFailed,
    setMethod: setSelectedMethod,
    setAmount: setSelectedAmount,
    setOtherAmount,
    handleControllerChange,
    handleFormSubmit,
  }
}
